import React, { useContext, useEffect, useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    Form,
    Row,
    Col
} from "reactstrap";
import Select from "react-select";
import InputMask from "react-input-mask";
import { CustoContext } from "../../context/CustoContext";
import { CategoriaFinanceiraContext } from "../../context/CategoriaFinanceiraContext";
import { ContaFinanceiraContext } from "../../context/ContaFinanceiraContext";
import { FormaPagamentoContext } from "../../context/FormaPagamentoContext";
import { TipoContaPagarContext } from "../../context/TipoContaPagarContext";
import { AuthContext } from "../../context/AuthContext";
import { CreateCustoType } from "../../context/hooks/useCusto";
import { ContratoContext } from "../../context/ContratoContext";
import { TipoCustoContext } from "../../context/TipoCustoContext";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onCreated: () => void;
}

export const CreateMultiplasContasPagarModal: React.FC<Props> = ({ isOpen, toggle, onCreated }) => {
    const { createCustosWithContaPagar } = useContext(CustoContext);
    const { objUserTk } = useContext(AuthContext);
    const { listCategoriaFinanceiraByEmpresa, handleGetCategoriaFinanceiraByEmpresaId } = useContext(CategoriaFinanceiraContext);
    const { listContaFinanceiraByEmpresa, handleGetContaFinanceiraByEmpresaId } = useContext(ContaFinanceiraContext);
    const { listFormaPagamentoByEmpresa, handleGetFormaPagamentoByEmpresaId } = useContext(FormaPagamentoContext);
    const { listTipoContaPagarByEmpresa, handleGetTipoContaPagarByEmpresaId } = useContext(TipoContaPagarContext);
    const { listContrato, handleGetContratoByEmpresaId } = useContext(ContratoContext);
    const { listTipoCusto, getAllTipoCustoPaged } = useContext(TipoCustoContext);

    const [custos, setCustos] = useState<CreateCustoType[]>([]);
    const [form, setForm] = useState({
        contaFinanceiraId: 0,
        categoriaFinanceiraId: 0,
        formaPagamentoId: 0,
        vencimento: "",
        documento: "",
        historico: "",
        bandeira: "",
        tipoContaPagarId: 0
    });

    useEffect(() => {
        if (objUserTk?.EmpresaId) {
            handleGetCategoriaFinanceiraByEmpresaId(objUserTk.EmpresaId);
            handleGetContaFinanceiraByEmpresaId(objUserTk.EmpresaId);
            handleGetFormaPagamentoByEmpresaId(objUserTk.EmpresaId);
            handleGetContratoByEmpresaId(objUserTk.EmpresaId);
            handleGetTipoContaPagarByEmpresaId(objUserTk.EmpresaId);
            getAllTipoCustoPaged(1, 9999, objUserTk.EmpresaId, true);
        }
    }, [objUserTk?.EmpresaId]);

    const handleAddCusto = () => {
        setCustos([...custos, {
            description: "",
            individualValue: 0,
            currentBalance: 1,
            empresaId: objUserTk.EmpresaId,
            contratoId: 0,
            tipoCustoId: 0,
        }]);
    };

    const handleChangeCusto = (index: number, field: keyof CreateCustoType, value: any) => {
        const newCustos = [...custos];
        (newCustos[index] as any)[field] = value;
        setCustos(newCustos);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        await createCustosWithContaPagar({
            empresaId: objUserTk.EmpresaId,
            contaFinanceiraId: form.contaFinanceiraId,
            categoriaFinanceiraId: form.categoriaFinanceiraId,
            formaPagamentoId: form.formaPagamentoId,
            vencimento: form.vencimento,
            documento: form.documento,
            historico: form.historico,
            bandeira: form.bandeira,
            custos: custos,
            tipoContaPagarId: form.tipoContaPagarId,
        });
        toggle();
        onCreated();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl">
            <ModalHeader toggle={toggle}>Adicionar múltiplas contas</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="form-control-label">Conta Financeira</Label>
                                <Select options={listContaFinanceiraByEmpresa.map(c => ({ value: c.id, label: c.name }))} onChange={e => setForm(prev => ({ ...prev, contaFinanceiraId: e?.value || 0 }))} classNamePrefix="react-select" placeholder="Selecione uma conta financeira" />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="form-control-label">Categoria Financeira</Label>
                                <Select options={listCategoriaFinanceiraByEmpresa.map(c => ({ value: c.id, label: c.name }))} onChange={e => setForm(prev => ({ ...prev, categoriaFinanceiraId: e?.value || 0 }))} classNamePrefix="react-select" placeholder="Selecione uma categoria" />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="form-control-label">Forma de Pagamento</Label>
                                <Select options={listFormaPagamentoByEmpresa.map(f => ({ value: f.id, label: f.name }))} onChange={e => setForm(prev => ({ ...prev, formaPagamentoId: e?.value || 0 }))} classNamePrefix="react-select" placeholder="Selecione a forma de pagamento" />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="form-control-label">Vencimento</Label>
                                <Input type="date" value={form.vencimento} onChange={e => setForm(prev => ({ ...prev, vencimento: e.target.value }))} className="form-control-alternative" placeholder="Selecione a data de vencimento" />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="form-control-label">Tipo de Conta Pagar</Label>
                                <Select options={listTipoContaPagarByEmpresa.map(tp => ({ value: tp.id, label: tp.name }))} onChange={e => setForm(prev => ({ ...prev, tipoContaPagarId: e?.value || 0 }))} classNamePrefix="react-select" placeholder="Selecione o tipo de conta a pagar" />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="form-control-label">Documento</Label>
                                <Input
                                    value={form.documento}
                                    onChange={e => setForm(prev => ({ ...prev, documento: e.target.value }))}
                                    className="form-control-alternative"
                                    placeholder="Informe o número do documento"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="form-control-label">Histórico</Label>
                                <Input value={form.historico} onChange={e => setForm(prev => ({ ...prev, historico: e.target.value }))} className="form-control-alternative" placeholder="Descrição resumida da transação" />
                            </FormGroup>
                        </Col>
                    </Row>
                    <FormGroup>
                        <Label className="form-control-label">Bandeira</Label>
                        <Input value={form.bandeira} onChange={e => setForm(prev => ({ ...prev, bandeira: e.target.value }))} className="form-control-alternative" placeholder="Visa, MasterCard, Pix, etc." />
                    </FormGroup>

                    <h5 className="mb-3">Custos dos contratos</h5>
                    {custos.map((custo, index) => (
                        <Row key={index} className="border p-3 mb-3 rounded">
                            <Col md={3}>
                                <Label className="form-control-label">Descrição</Label>
                                <Input className="form-control-alternative" placeholder="Ex: Custo do fornecedor X" value={custo.description} onChange={e => handleChangeCusto(index, 'description', e.target.value)} />
                            </Col>
                            <Col md={3}>
                                <Label className="form-control-label">Valor Unitário</Label>
                                <Input className="form-control-alternative" type="number" placeholder="R$ 0,00" value={custo.individualValue} onChange={e => handleChangeCusto(index, 'individualValue', parseFloat(e.target.value))} />
                            </Col>
                            <Col md={3}>
                                <Label className="form-control-label">Contrato</Label>
                                <Select classNamePrefix="react-select" placeholder="Selecione um contrato" options={listContrato.map(c => ({ value: c.id, label: `${c.id} - ${c.description}` }))} onChange={opt => handleChangeCusto(index, 'contratoId', opt?.value || 0)} />
                            </Col>
                            <Col md={3}>
                                <Label className="form-control-label">Tipo de Custo</Label>
                                <Select classNamePrefix="react-select" placeholder="Selecione o tipo de custo" options={listTipoCusto.map(tc => ({ value: tc.id, label: tc.description }))} onChange={opt => handleChangeCusto(index, 'tipoCustoId', opt?.value || 0)} />
                            </Col>
                        </Row>
                    ))}
                    <Button style={{ background: '#585858', color: '#fff' }} onClick={handleAddCusto}>Adicionar Custo</Button>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button style={{ background: '#585858', color: '#fff' }} onClick={handleSubmit}>Salvar</Button>{" "}
                <Button style={{ background: '#585858', color: '#fff' }} onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};